import { ENVIRONMENT } from "../Http/API";
import { AddWebhook } from "../Layout/Salesforce/AddWebhook";
import ChooseSalesforceAccountType from "../Layout/Salesforce/ChooseSalesforceAccountType copy";
import ChooseSalesProductPriceBook from "../Layout/Salesforce/ChooseSalesProductPriceBook";
import CreditNoteCustomFindWithTrigger from "../Layout/Salesforce/CreaditNoteCustomFindWIthTrigger";
import CreditNoteFindData from "../Layout/Salesforce/CreditNoteFindData";
import CreditNoteSelectTriggerObject from "../Layout/Salesforce/CreditNoteSelectTriggerObject";
import CreditNoteTestTrigger from "../Layout/Salesforce/CreditNoteTestTrigger";
import CustomFindWithTrigger from "../Layout/Salesforce/CustomFindWithTrigger";
import CustomFindQuoteWithTrigger from "../Layout/Salesforce/CustomFindQuoteWithTrigger";
import CustomizeRecordToFind from "../Layout/Salesforce/CustomizeRecordToFind";
import FindCreditNoteLineItem from "../Layout/Salesforce/FindCreditNoteLineItem";
import FindData from "../Layout/Salesforce/FindData";
import FindDataWithTriggerForWcCustomer from "../Layout/Salesforce/FindDataWithTriggerForWcCustomer";
import PaymentCustomizeRecordToFind from "../Layout/Salesforce/PaymentCustomFindWithTrigger";
import SalesCreditMapping from "../Layout/Salesforce/SalesCreditMapping";
import SalesItemForm from "../Layout/Salesforce/SalesItemForm";
import SalesPaymentItemForm from "../Layout/Salesforce/SalesPaymentItemForm";
import SalesProductCreateForm from "../Layout/Salesforce/SalesProductCreateForm";
import SelectTriggerObject from "../Layout/Salesforce/SelectTriggerObject";
import TestTrigger from "../Layout/Salesforce/TestTrigger";
import ChooseAccount from "../Layout/stepUtils/ChooseAccount";
import ChooseMultiCurrencyOption from "../Layout/Woocommerce/ChooseMultiCurrencyOption";
import FindSfAccountForWcOrder from "../Layout/Woocommerce/FindSfAccountForWcOrder";
import FindSfProductForWcOrder from "../Layout/Woocommerce/FindSfProductForWcOrder";
import ProductFindWithTriggerForWoocommerce from "../Layout/Woocommerce/ProductFindWithTriggerForWoocommerce";
import WcSalesforceContactMappingForm from "../Layout/Woocommerce/WcSalesforceContactMappingForm";
import WcSalesforceOpportunityMappingForm from "../Layout/Woocommerce/WcSalesforceOpportunityMappingForm";
import InvoiceUpdateForm from "../Layout/Xero/InvoiceUpdateForm";
import QuoteUpdateForm from "../Layout/Xero/QuoteUpdateForm";
import TransactionForm from "../Layout/Salesforce/TransactionForm";
import TransactionFindData from "../Layout/Salesforce/TransactionFindData";
import FindTransactionLineItem from "../Layout/Salesforce/FindTransactionLineItem";
import TransactionCustomFindWIthTrigger from "../Layout/Salesforce/TransactionCustomFindWIthTrigger";
import ChooseBankTransactionStatus from "../Layout/Xero/ChooseBankTransactionStatus";

const callback = ENVIRONMENT;

const SFDC_CALLBACK = callback.sfdc_callback;
const SFDC_CLIENT_ID = callback.sfc_client_id;

const SFDC_COMMON = [
  {
    title: "Choose Account",
    content: () => (
      <ChooseAccount
        authRequestFunction={(environment, cb) => {
          window.SFDC_ENV = environment;
          const url = `https://${environment}.salesforce.com/services/oauth2/authorize?response_type=code&client_id=${SFDC_CLIENT_ID}&redirect_uri=${SFDC_CALLBACK}`;
          const popWindow = window.open(
            url,
            "newwindow",
            "width=1000,height=600",
          );
          const syncWindow = setInterval(() => {
            //console.log('open');
            if (popWindow.closed) {
              cb();
              //console.log('closed');
              clearInterval(syncWindow);
            }
          }, 500);
        }}
      />
    ),
  },
];

const SFDC_NEW_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Connect Webhook",
      content: () => <AddWebhook />,
    },
  ],
};

const SFDC_UPDATE_PRODUCT_DETAILS = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Connect Webhook",
      content: () => <AddWebhook />,
    },
  ],
};

const SFDC_FIND_RECORD = {
  steps: [
    {
      title: "Customize Record",
      content: () => <CustomizeRecordToFind />,
    },
    {
      title: "Find Data",
      content: () => <FindData />,
    },
  ],
};

const SALES_FORCE_CREATE_NEW_SALES_INVOICE = {
  steps: [...SFDC_COMMON],
};

const SALES_FORCE_CREATE_NEW_PRODUCT_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Customize Record",
      content: () => <SalesItemForm />,
    },
  ],
};

const SFDC_UPDATE_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <CustomFindWithTrigger />,
    },
    {
      title: "Invoice Mapping",
      content: () => <InvoiceUpdateForm />,
    },
  ],
};

const SFDC_CREATE_OR_UPDATE_PAYMENT = {
  steps: [
    ...SFDC_COMMON,

    {
      title: "Find Salesforce Object",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Find Parent Record",
      content: () => <PaymentCustomizeRecordToFind />,
    },
    {
      title: "Payment Mapping",
      content: () => <SalesPaymentItemForm />,
    },
  ],
};

const SFDC_CREATE_OR_UPDATE_TRANSACTION = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Choose BankTransaction Status",
      content: () => <ChooseBankTransactionStatus />,
    },
    {
      title: "Find Salesforce Object",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Find Child Salesforce Object",
      content: () => <FindTransactionLineItem />,
    },
    {
      title: "Find Data",
      content: () => <TransactionFindData showNext={true} />,
    },
    {
      title: "Customize Record",
      content: () => <TransactionForm />,
    },
  ],
};

const SFDC_CREATE_UPDATE_CREDIT_NOTE = {
  steps: [
    ...SFDC_COMMON,

    {
      title: "Find Parent Salesforce Object",
      content: () => <CreditNoteSelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <CreditNoteTestTrigger showNext={true} />,
    },
    {
      title: "Find Child Salesforce Object",
      content: () => <FindCreditNoteLineItem />,
    },
    {
      title: "Find Data",
      content: () => <CreditNoteFindData showNext={true} />,
    },
    {
      title: "Find Credit Note Parent Record",
      content: () => <CreditNoteCustomFindWithTrigger />,
    },
    {
      title: "Customize Record",
      content: () => <SalesCreditMapping />,
    },
  ],
};

const SFDC_UPDATE_QUOTE = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <CustomFindQuoteWithTrigger />,
    },
    {
      title: "Quote Mapping",
      content: () => <QuoteUpdateForm />,
    },
  ],
};

const SFDC_TRIGGER_XERO_PDF = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Connect Webhook",
      content: () => <AddWebhook />,
    },
  ],
};

//for woocommerce
const SFDC_SYNC_WC_PRODUCT = {
  steps: [
    ...SFDC_COMMON,

    {
      title: "Select Salesforce Price Book",
      content: () => <ChooseSalesProductPriceBook />,
    },
    {
      title: "Find Parent Record",
      content: () => <ProductFindWithTriggerForWoocommerce />,
    },
    {
      title: "Product Mapping",
      content: () => <SalesProductCreateForm />,
    },
  ],
};

const SFDC_SYNC_ACCOUNT = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Select Account Type",
      content: () => <ChooseSalesforceAccountType />,
    },
    {
      title: "Find Parent Record",
      content: () => <FindDataWithTriggerForWcCustomer />,
    },
    {
      title: "Customize Record",
      content: () => <WcSalesforceContactMappingForm />,
    },
  ],
};

const SFDC_SYNC_OPPORTUNITY = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Find Account Record",
      content: () => <FindSfAccountForWcOrder />,
    },
    {
      title: "Select Salesforce Price Book",
      content: () => <ChooseSalesProductPriceBook />,
    },
    {
      title: "Multi Currency Enabled",
      content: () => <ChooseMultiCurrencyOption />,
    },
    {
      title: "Find Product Record",
      content: () => <FindSfProductForWcOrder />,
    },
    {
      title: "Customize Record",
      content: () => <WcSalesforceOpportunityMappingForm />,
    },
  ],
};
const SFDC_UPDATE_OPPORTUNITY = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Find Account Record",
      content: () => <FindSfAccountForWcOrder />,
    },
    {
      title: "Select Salesforce Price Book",
      content: () => <ChooseSalesProductPriceBook />,
    },
    {
      title: "Multi Currency Enabled",
      content: () => <ChooseMultiCurrencyOption />,
    },
    {
      title: "Find Product Record",
      content: () => <FindSfProductForWcOrder />,
    },
    {
      title: "Customize Record",
      content: () => <WcSalesforceOpportunityMappingForm />,
    },
  ],
};

export {
  SFDC_NEW_RECORD,
  SFDC_FIND_RECORD,
  SALES_FORCE_CREATE_NEW_SALES_INVOICE,
  SALES_FORCE_CREATE_NEW_PRODUCT_RECORD,
  SFDC_UPDATE_RECORD,
  SFDC_CREATE_OR_UPDATE_PAYMENT,
  SFDC_CREATE_UPDATE_CREDIT_NOTE,
  SFDC_UPDATE_QUOTE,
  SFDC_TRIGGER_XERO_PDF,
  SFDC_CREATE_OR_UPDATE_TRANSACTION,
  SFDC_SYNC_WC_PRODUCT,
  SFDC_SYNC_ACCOUNT,
  SFDC_SYNC_OPPORTUNITY,
  SFDC_UPDATE_OPPORTUNITY,
  SFDC_UPDATE_PRODUCT_DETAILS,
};
